namespace RioERP.Masters {
    export interface TaxTypesRow {
        Id?: number;
        Name?: string;
    }

    export namespace TaxTypesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.TaxTypes';
        export const lookupKey = 'Masters.TaxTypes';

        export function getLookup(): Q.Lookup<TaxTypesRow> {
            return Q.getLookup<TaxTypesRow>('Masters.TaxTypes');
        }
        export const deletePermission = 'Masters:MastersManagement:Modify';
        export const insertPermission = 'Masters:MastersManagement:Modify';
        export const readPermission = 'Masters:MastersManagement:View';
        export const updatePermission = 'Masters:MastersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name"
        }
    }
}
